<template>
  <v-dialog 
    v-model="activeMode"
    max-width="400"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon color="primary">mdi-cog</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Настройка статистики</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

      </v-toolbar>

      <v-card-text>
        <div class="mt-3 mb-3">
          Укажите правила начисления баллов за клиентов в зависимости от их статуса. 
          Эти данные будут применены к статистике.
        </div>
        <v-form ref="form" v-model="isValidWeights">
          <v-text-field
            v-for="item in $store.state.customers.statuses"
            :key="item.value"
            :label="item.text"
            v-model="weights[item.value]"
            filled
            :rules="[v => isNumber(v) || 'Введите число.']"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save()"
        >Сохранить</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'stat-settings',

  data() {
    return {
      activeMode: false,
      isValidWeights: true,
      weights: _.cloneDeep(this.$store.state.customers.statWeights)
    }
  },

  methods: {
    save() {
      this.$refs.form.validate();
      if (this.isValidWeights) {
        this.$store.dispatch('customers/setWeights', this.weights);
        this.$store.dispatch('showMessage', 'Настройки статистики успешно обновлены.');
        this.closeForm();
      }
    },
    closeForm() {
      this.weights = _.cloneDeep(this.$store.state.customers.statWeights);
      this.$refs.form.resetValidation();
      this.activeMode = false;
    }
  }
}
</script>